<template>
  <i class="inline-block">
    <svg
      v-if="name == 'pencil-solid'"
      fill="currentColor"
      :class="iconClass"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
    >
      <g>
        <path
          d="M492.6,58.1l-39.3-39.4c-25-25-65.5-25-90.5,0h-0.1l-14.4,14.5l-22.6,22.6l-11.4,11.3l33.9,33.9l62.1,62.1l33.9,33.9
          l11.3-11.3l22.6-22.6l14.5-14.5C517.6,123.6,517.6,83.1,492.6,58.1z"
        />
        <path
          d="M325.6,123.7l-33.9-33.9l-11.3,11.3l-22.6,22.6L58.6,322.9c-10.4,10.4-18,23.3-22.2,37.4L1,480.7
          c-2.5,8.4-0.2,17.5,6.1,23.7c6.3,6.2,15.3,8.5,23.7,6.1l120.3-35.4c14.1-4.2,27-11.8,37.4-22.2l199.2-199.2l22.6-22.7l11.3-11.3
          l-33.9-33.9L325.6,123.7z M150.4,441.5L80.7,462l-31.3-31.3l20.5-69.6c2-7.2,5.5-13.7,10.1-19.4l33.1-13.3v46.7
          c0,12.8,10.5,23.4,23.4,23.4h46.7l-13.2,33C164,436,157.4,439.3,150.4,441.5z M315.3,186.7l-144,144c-6.2,6.2-16.4,6.2-22.6,0
          s-6.2-16.4,0-22.6l144-144c6.2-6.2,16.4-6.2,22.6,0C321.5,170.3,321.5,180.5,315.3,186.7z"
        />
      </g>
    </svg>
    <svg
      v-if="name == 'lightning-bolt-solid'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      width="56.911"
      height="69.131"
      viewBox="0 0 56.911 69.131"
    >
      <path
        d="M43.037-58.145a4.159,4.159,0,0,1,1.4,4.824L34.4-28.437H52.813a3.853,3.853,0,0,1,3.809,2.666,4.123,4.123,0,0,1-1.143,4.57L18.916,9.268a4.193,4.193,0,0,1-5.078.127,4.159,4.159,0,0,1-1.4-4.824L22.471-20.312H4.063A4.086,4.086,0,0,1,.254-22.979a3.975,3.975,0,0,1,1.27-4.57L38.086-58.018A4,4,0,0,1,43.037-58.145Z"
        transform="translate(0.016 58.941)"
        fill="#fff"
      />
    </svg>
    <svg
      v-if="name == 'document-bumper'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      width="48.75"
      height="65"
      viewBox="0 0 48.75 65"
    >
      <path
        d="M-24.375-48.75a8.182,8.182,0,0,1,8.125-8.125H2.793a8.076,8.076,0,0,1,5.713,2.412L21.963-41.006a8.373,8.373,0,0,1,2.412,5.84V0A8.182,8.182,0,0,1,16.25,8.125h-32.5A8.182,8.182,0,0,1-24.375,0Zm26.406-.635v11.807a3.089,3.089,0,0,0,3.047,3.047H17.012ZM-13.2-48.75A3.089,3.089,0,0,0-16.25-45.7,3.089,3.089,0,0,0-13.2-42.656h6.094A3.089,3.089,0,0,0-4.062-45.7,3.089,3.089,0,0,0-7.109-48.75Zm0,12.188a3.089,3.089,0,0,0-3.047,3.047A3.089,3.089,0,0,0-13.2-30.469h6.094a3.089,3.089,0,0,0,3.047-3.047,3.089,3.089,0,0,0-3.047-3.047ZM-4.316-16.25A4.692,4.692,0,0,0-8-14.473l-7.617,9.521a3.17,3.17,0,0,0,.508,4.316,3.17,3.17,0,0,0,4.316-.508l5.967-7.49,1.9,6.475A3.009,3.009,0,0,0,0,0H13.2A3.089,3.089,0,0,0,16.25-3.047,3.089,3.089,0,0,0,13.2-6.094H2.285L.254-12.949A4.805,4.805,0,0,0-4.316-16.25Z"
        transform="translate(24.375 56.875)"
        fill="#fff"
      />
    </svg>
    <svg
      v-if="name == 'arrow-dual-interaction-solid'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="65"
      viewBox="0 0 65 65"
    >
      <path
        d="M63.857-37.705,51.67-25.518a4.3,4.3,0,0,1-5.84,0,4.3,4.3,0,0,1,0-5.84l5.332-5.205H4.063A4.011,4.011,0,0,1,0-40.625a4.011,4.011,0,0,1,4.063-4.062h47.1L45.83-49.893a4.3,4.3,0,0,1,0-5.84,4.3,4.3,0,0,1,5.84,0L63.857-43.545A4.3,4.3,0,0,1,63.857-37.705ZM13.33,6.982,1.143-5.205a4.3,4.3,0,0,1,0-5.84L13.33-23.232a4.3,4.3,0,0,1,5.84,0,4.3,4.3,0,0,1,0,5.84l-5.332,5.205h47.1A4.011,4.011,0,0,1,65-8.125a4.011,4.011,0,0,1-4.062,4.063h-47.1L19.17,1.143a4.3,4.3,0,0,1,0,5.84A4.3,4.3,0,0,1,13.33,6.982Z"
        transform="translate(0 56.875)"
        fill="#fff"
      />
    </svg>
    <svg
      v-else-if="name == 'rotate-regular'"
      fill="currentColor"
      :class="iconClass"
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
    >
      <path
        d="M94,187.1C120.8,124.1,183.3,80,256,80c39.7,0,77.8,15.8,105.9,43.9l4.1,4.1l-35.7,35.7c-12.6,12.6-14.6,34.1-0.4,50.3
      c4.9,5.6,15.1,10,22.6,10h121.4c12.2,0,22.1-9.9,22.1-22.1V80.3c0-9.6-4.4-18.8-12.2-24.4c-16.5-11.9-35.9-9.5-48.1,2.5L400,94.1
      l-4.1-4.1C358.8,52.8,308.5,32,256,32C163.4,32,83.9,88.2,49.8,168.3c-5.2,12.2,0.5,26.3,12.7,31.5S88.8,199.3,94,187.1z M462,344.1
      c5.2-12.2-0.4-26.3-12.6-31.5s-26.3,0.4-31.5,12.6C391,388.1,328.6,432,256,432c-39.7,0-77.8-15.8-105.9-43.9L146,384l35.7-35.7
      c12.6-12.6,14.6-34.1,0.4-50.3c-4.9-5.6-15.1-10-22.6-10H38.1c-12.2,0-22.1,9.9-22.1,22.1l0,121.7c0,10,4.9,19.4,13.1,25
      c16.3,11.2,35.3,8.7,47.2-3.1l35.7-35.8l4.1,4.1c37.1,37.2,87.4,58,139.9,58C348.5,480,427.8,424,462,344.1z"
      />
    </svg>
    <svg
      v-else-if="name == 'file-pdf-regular-full-svg'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        d="M240 112L128 112C119.2 112 112 119.2 112 128L112 512C112 520.8 119.2 528 128 528L208 528L208 576L128 576C92.7 576 64 547.3 64 512L64 128C64 92.7 92.7 64 128 64L261.5 64C278.5 64 294.8 70.7 306.8 82.7L429.3 205.3C441.3 217.3 448 233.6 448 250.6L448 400.1L400 400.1L400 272.1L312 272.1C272.2 272.1 240 239.9 240 200.1L240 112.1zM380.1 224L288 131.9L288 200C288 213.3 298.7 224 312 224L380.1 224zM272 444L304 444C337.1 444 364 470.9 364 504C364 537.1 337.1 564 304 564L292 564L292 592C292 603 283 612 272 612C261 612 252 603 252 592L252 464C252 453 261 444 272 444zM304 524C315 524 324 515 324 504C324 493 315 484 304 484L292 484L292 524L304 524zM400 444L432 444C460.7 444 484 467.3 484 496L484 560C484 588.7 460.7 612 432 612L400 612C389 612 380 603 380 592L380 464C380 453 389 444 400 444zM432 572C438.6 572 444 566.6 444 560L444 496C444 489.4 438.6 484 432 484L420 484L420 572L432 572zM508 464C508 453 517 444 528 444L576 444C587 444 596 453 596 464C596 475 587 484 576 484L548 484L548 508L576 508C587 508 596 517 596 528C596 539 587 548 576 548L548 548L548 592C548 603 539 612 528 612C517 612 508 603 508 592L508 464z"
      />
    </svg>
    <svg
      v-else-if="name == 'flag-regular'"
      fill="currentColor"
      :class="iconClass"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 525 512"
      style="enable-background: new 0 0 525 512"
      xml:space="preserve"
    >
      <path
        d="M48,24C48,10.7,37.3,0,24,0S0,10.7,0,24v40v286.5V400v88c0,13.3,10.7,24,24,24s24-10.7,24-24V388l157.3-20.1
        c41.1-10.3,84.6-5.5,122.5,13.4c44.2,22.1,95.5,24.8,141.7,7.4l34.7-13c12.5-4.7,20.8-16.6,20.8-30V66.1c0-23-24.2-38-44.8-27.7
        l-9.6,4.8c-46.3,23.2-100.8,23.2-147.1,0c-35.1-17.6-75.4-22-113.5-12.5L48,52V24z M48,101.5l173.6-24.2c27-6.7,55.5-3.6,80.4,8.8
        c54.9,27.4,118.7,29.7,175,6.8v241.8l-24.4,9.1c-33.7,12.6-71.2,10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48,338.5V101.5z"
      />
    </svg>
    <svg
      v-else-if="name == 'handshake-regular'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 640 512"
      style="enable-background: new 0 0 640 512"
      xml:space="preserve"
    >
      <path
        d="M285.3,74.4c7.1,5.6,28.4,24.6,26.5,26.5L263,131.4c-0.4,0.4-22.6-18.8-42.7-17.5c-15.6,1-28.9,11.9-40.7,22.3L153,159.8
      c-10.2,9.1-23.5,14.1-37.2,14.1H99.1c-1.7,0-3.1,1.4-3.1,3.1v121.9c0,1.7,1.3,3,2.9,3.1c19.3,1.3,37.6,9.5,51.4,23.3l35.6,35.6l7,7
      l0,0l27,27c6.2,6.2,16.4,6.2,22.6,0c1.7-1.7,3-3.7,3.7-5.8c2.8-7.7,9.3-13.5,17.3-15.3s16.4,0.6,22.2,6.5l10.8,10.6
      c11.6,11.6,30.4,11.6,41.9,0c5.4-5.4,8.3-12.3,8.6-19.4c0.4-8.8,5.6-16.6,13.6-20.4s17.3-3,24.4,2.1c9.4,6.7,22.5,5.8,30.9-2.6
      c9.4-9.4,9.4-24.6,0-33.9L342.2,243c-1.2-1.2-3.1-1.2-4.4-0.1l-33.6,31c-27.3,25.2-69.2,25.6-97,0.9c-31.7-28.2-32.4-77.4-1.6-106.5
      l70.1-66.2c27.4-25.8,63.6-40.2,101.3-40.2c36.1,0,71,13.3,97.9,37.2l29.2,26c0.6,0.5,1.3,0.8,2.1,0.8H544h40h36.9
      c10.5,0,19.1,8.6,19.1,19.1v201.7c0,19.4-15.7,35.1-35.1,35.1H576c-11.2,0-21.2-5.8-26.8-14.6c-0.6-0.9-1.6-1.4-2.6-1.4l-81.2,0
      c-1.2,0-2.2,0.7-2.8,1.7c-3.3,6.1-7.5,11.9-12.6,17C433.3,401.2,410.6,408,389,405c-1.3-0.2-2.5,0.5-3.1,1.6
      c-3.5,6.6-8.1,12.7-13.6,18.3c-26.7,26.7-68.2,29.9-98.5,9.4c-1.1-0.8-2.6-0.8-3.7,0.1c-25.1,19.3-61.3,17.6-84.2-5.5l-26.9-27l-7-7
      l-35.6-35.6c-4.6-4.6-10.5-7.7-16.9-8.8c-1.8-0.3-3.5,0.9-3.7,2.7c-1.6,16.1-15.3,28.7-31.8,28.7H35.1C15.7,381.9,0,366.2,0,346.8
      V145c0-10.5,8.6-19.1,19.1-19.1H56h40h19.8c2,0,3.9-0.7,5.3-2l26.5-23.6c21-18.6,44.6-30.9,70.9-35.9c12.7-2.4,25.6-2.6,38.4-1.1
      C256.9,63.3,275.2,66.5,285.3,74.4z M544,317.9V177c0-1.7-1.4-3.1-3.1-3.1H496c-5.9,0-11.6-2.2-15.9-6.1L443.2,135
      c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4,0-49.8,9.7-68.3,27.1l-70.1,66.2c-10.3,9.8-10.1,26.3,0.5,35.7c9.3,8.3,23.4,8.1,32.5-0.3
      l71.9-66.4c9.7-9,24.9-8.4,33.9,1.4s8.4,24.9-1.4,33.9l-0.8,0.8l74.4,74.4c9.4,9.4,15.7,20.8,18.8,32.8c0.4,1.4,1.6,2.3,3,2.3H544
      V317.9z M64,333.9c0-8.8-7.2-16-16-16s-16,7.2-16,16s7.2,16,16,16S64,342.7,64,333.9z M592,349.9c8.8,0,16-7.2,16-16s-7.2-16-16-16
      s-16,7.2-16,16S583.2,349.9,592,349.9z"
      />
      <path
        d="M331.2,499.9h-22.4c-7.9,0-14.3-6.4-14.3-14.3V23.9c0-7.9,6.4-14.3,14.3-14.3h22.4c7.9,0,14.3,6.4,14.3,14.3v461.7
      C345.5,493.5,339.1,499.9,331.2,499.9z"
      />
    </svg>
    <svg
      v-else-if="name == 'info-solid'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 192 512"
      style="enable-background: new 0 0 192 512"
      xml:space="preserve"
    >
      <path
        d="M32,418h32V226H32H10.8c-6,0-10.8-4.9-10.8-10.8v-42.3c0-6,4.9-10.8,10.8-10.8H32h85.2c6,0,10.8,4.9,10.8,10.8V418h32
       M160,482H32"
      />
      <path
        d="M192,427.4c0-5.2-4.2-9.4-9.4-9.4H128H9.4c-5.2,0-9.4,4.2-9.4,9.4v45.1c0,5.2,4.2,9.4,9.4,9.4h173.1c5.2,0,9.4-4.2,9.4-9.4
      V427.4z"
      />
      <path
        d="M96,133.6L96,133.6c-29.6,0-53.6-24-53.6-53.6v0c0-29.6,24-53.6,53.6-53.6h0c29.6,0,53.6,24,53.6,53.6v0
      C149.6,109.6,125.6,133.6,96,133.6z"
      />
    </svg>

    <svg
      v-else-if="name == 'check-regular'"
      fill="currentColor"
      :class="iconClass"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
    >
      <path
        d="M415.2,117.4c9.7,9.1,10.2,24.3,1.1,33.9L194.9,393.5c-9.1,9.7-24.3,10.2-33.9,1.1L32.8,264.2c-9.7-9.1-10.2-24.3-1.1-33.9
      c9.1-9.6,24.3-10.2,33.9-1.1l109.1,112.4c0.8,0.9,2.2,0.8,3,0l203.5-223C390.3,108.8,405.5,108.3,415.2,117.4L415.2,117.4z"
      />
    </svg>
    <svg
      v-else-if="name == 'address-card-regular'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 576 512"
      style="enable-background: new 0 0 576 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M191.1,264.1c35.4,1.1,64.4-27.8,63.3-63.3c-1-32.1-27.2-58.2-59.2-59.2c-35.4-1.1-64.4,27.8-63.3,63.3
      C132.9,236.9,159,263.1,191.1,264.1z M436.1,230.2h-84.6c-12.9,0-23.7,10.5-23.5,23.4c0.2,12.5,10.4,22.5,23,22.5h84.6
      c12.9,0,23.7-10.5,23.5-23.4C458.9,240.2,448.7,230.2,436.1,230.2z M466.1,296.2H351.5c-12.9,0-23.7,10.5-23.5,23.4
      c0.2,12.5,10.4,22.5,23,22.5h114.6c12.9,0,23.7-10.5,23.5-23.4C488.9,306.2,478.7,296.2,466.1,296.2z M227.8,278.5h-69.3
      c-28.9,0-54.1,16-67.1,39.7c-13,23.5,4.4,52.3,31.2,52.3h141.1c26.8,0,44.2-28.8,31.2-52.3C281.9,294.5,256.7,278.5,227.8,278.5z
       M436.1,164.6h-84.6c-12.9,0-23.7,10.5-23.5,23.4c0.2,12.5,10.4,22.5,23,22.5h84.6c12.9,0,23.7-10.5,23.5-23.4
      C458.9,174.6,448.7,164.6,436.1,164.6z M502.5,41.5h-429c-33.8,0-61.3,27.4-61.3,61.3v306.4c0,33.8,27.4,61.3,61.3,61.3h429
      c33.8,0,61.3-27.4,61.3-61.3V102.8C563.8,68.9,536.3,41.5,502.5,41.5z M517.8,409.2c0,8.5-6.9,15.3-15.3,15.3h-429
      c-8.5,0-15.3-6.9-15.3-15.3V102.8c0-8.5,6.9-15.3,15.3-15.3h429c8.5,0,15.3,6.9,15.3,15.3V409.2z"
      />
    </svg>
    <svg
      v-else-if="name == 'angle-down-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M201.4,374.6c12.5,12.5,32.8,12.5,45.3,0l159.5-159.5c12.3-12.3,13.1-32.4,1.1-45.1
      c-12.4-13.2-33.2-13.4-45.9-0.7l-132,132c-3,3-7.8,3-10.7,0l-132-131.9c-12.7-12.7-33.5-12.5-45.9,0.7c-12,12.7-11.2,32.8,1.1,45.1
      l159.5,159.5L201.4,374.6z"
      />
    </svg>
    <svg
      v-else-if="name == 'angle-right-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 320 512"
      style="enable-background: new 0 0 320 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M278.6,233.4c12.5,12.5,12.5,32.8,0,45.3L119.1,438.2c-12.3,12.3-32.4,13.1-45.1,1.1
      c-13.2-12.4-13.4-33.2-0.7-45.9L205.7,261c2.8-2.8,2.8-7.3,0-10.1L73.4,118.6c-12.7-12.7-12.5-33.5,0.7-45.9
      c12.7-12,32.8-11.2,45.1,1.1l159.5,159.5L278.6,233.4z"
      />
    </svg>
    <svg
      v-else-if="name == 'arrow-up-left-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 384 512"
      style="enable-background: new 0 0 384 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M64,96c-17.7,0-32,14.3-32,32v203.3c0,18,14.7,33.1,32.7,32.7c17.4-0.4,31.3-14.5,31.3-32V211.9
      c0-2.4,2.9-3.7,4.7-1.9l196.7,196.6c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3L146,164.7c-1.7-1.7-0.5-4.7,1.9-4.7h119.4
      c18,0,33.1-14.7,32.7-32.7c-0.4-17.4-14.5-31.3-32-31.3H64z"
      />
    </svg>
    <svg
      v-else-if="name == 'arrow-right'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"
      />
    </svg>
    <svg
      v-else-if="name == 'bars-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M24,106c0-17.7,12.8-32,28.6-32h342.9c15.8,0,28.6,14.3,28.6,32s-12.8,32-28.6,32H52.6
      C36.8,138,24,123.7,24,106z M24,256c0-17.7,12.8-32,28.6-32h342.9c15.8,0,28.6,14.3,28.6,32s-12.8,32-28.6,32H52.6
      C36.8,288,24,273.7,24,256z M424,406c0,17.7-12.8,32-28.6,32H52.6C36.8,438,24,423.7,24,406s12.8-32,28.6-32h342.9
      C411.2,374,424,388.3,424,406z"
      />
    </svg>
    <svg
      v-else-if="name == 'cart-shopping-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 576 512"
      style="enable-background: new 0 0 576 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g>
        <path
          class="st0"
          d="M126.2,40.1c-2.1-11-11.7-18.9-22.9-18.9H33.5c-12.9,0-23.3,10.4-23.3,23.3c0,12.9,10.4,23.3,23.3,23.3H84
          l58.5,307c2.1,11,11.7,18.9,22.9,18.9h318.2c12.9,0,23.3-10.4,23.3-23.3c0-12.9-10.4-23.3-23.3-23.3H184.7l-8.8-46.6L128.6,52.3
          L126.2,40.1z"
        />
        <path
          class="st0"
          d="M197.8,409.9c-22.6,0-40.9,18.3-40.9,40.9c0,22.6,18.3,40.9,40.9,40.9c22.6,0,40.9-18.3,40.9-40.9
          C238.7,428.2,220.4,409.9,197.8,409.9z M197.8,465.1c-7.9,0-14.3-6.4-14.3-14.3c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3
          C212.1,458.7,205.7,465.1,197.8,465.1z"
        />
        <path
          class="st0"
          d="M443.5,409.9c-22.6,0-40.9,18.3-40.9,40.9c0,22.6,18.3,40.9,40.9,40.9c22.6,0,40.9-18.3,40.9-40.9
          C484.4,428.2,466.1,409.9,443.5,409.9z M443.5,465.1c-7.9,0-14.3-6.4-14.3-14.3c0-7.9,6.4-14.3,14.3-14.3c7.9,0,14.3,6.4,14.3,14.3
          C457.8,458.7,451.4,465.1,443.5,465.1z"
        />
        <path
          class="st0"
          d="M512.2,295.2l52.4-186.2c5.5-19.8-9.3-39.5-29.9-39.5H178.1c-17.3,0-30.3,15.7-27.1,32.7l36.8,193.2
          c2.5,13,13.8,22.4,27.1,22.4h267.5C496.2,317.8,508.4,308.6,512.2,295.2z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'chevron-up-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M233.4,105.4c12.5-12.5,32.8-12.5,45.3,0l191.5,191.5c12.3,12.3,13.1,32.4,1.1,45.1
      c-12.4,13.2-33.2,13.4-45.9,0.7L261.1,178.4c-2.8-2.8-7.4-2.8-10.2,0L86.6,342.6c-12.7,12.7-33.5,12.5-45.9-0.7
      c-12-12.7-11.2-32.8,1.1-45.1L233.4,105.4L233.4,105.4z"
      />
    </svg>
    <!-- circle-info-light -->
    <svg
      v-else-if="name == 'circle-info-light'"
      id="Ebene_1"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g>
        <path
          class="st0"
          d="M284.4,160.1c0,3.9-0.8,7.5-2.3,10.8c-1.5,3.3-3.6,6.2-6.2,8.8c-2.6,2.5-5.6,4.5-9.1,6
            c-3.5,1.4-7.2,2.2-11.2,2.2c-3.8,0-7.3-0.7-10.7-2.2c-3.4-1.4-6.3-3.4-8.9-6c-2.5-2.5-4.6-5.5-6.1-8.8c-1.5-3.3-2.2-6.9-2.2-10.8
            c0-3.9,0.7-7.5,2.2-10.9c1.5-3.4,3.5-6.3,6.1-8.9c2.5-2.5,5.5-4.5,8.9-6c3.4-1.4,6.9-2.2,10.7-2.2c4,0,7.7,0.7,11.2,2.2
            c3.5,1.4,6.5,3.4,9.1,6c2.6,2.5,4.7,5.5,6.2,8.9C283.6,152.6,284.4,156.3,284.4,160.1z M278.9,231.6v125.2
            c0,12.6-10.2,22.9-22.9,22.9h0c-12.6,0-22.9-10.2-22.9-22.9V231.6c0-12.6,10.2-22.9,22.9-22.9h0C268.6,208.7,278.9,219,278.9,231.6
            z"
        />
      </g>
      <path
        class="st0"
        d="M256,8.2C119.1,8.2,8.2,119.1,8.2,256S119.1,503.8,256,503.8S503.8,392.9,503.8,256S392.9,8.2,256,8.2z
          M256,472.8c-119.5,0-216.8-97.3-216.8-216.8S136.5,39.2,256,39.2S472.8,136.5,472.8,256S375.5,472.8,256,472.8z"
      />
    </svg>
    <svg
      v-else-if="name == 'circle-user-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M334.7,407.3c69.7-18.2,56.8-121-15.3-121.8c-0.5,0-0.9,0-1.4,0H194c-0.5,0-1,0-1.5,0
      c-72,0.8-84.9,103.6-15.2,121.8c15.6,4.1,61.9,6.2,78.7,6.2C272.9,413.5,319.2,411.3,334.7,407.3z M512,256
      c0,141.4-114.6,256-256,256C114.2,512,0,397.8,0,256C0,114.6,114.6,0,256,0C397.8,0,512,114.2,512,256z M253.7,254.5
      c41.7,1.3,75.6-32.6,74.3-74.3c-1.2-37.7-31.9-68.4-69.6-69.6c-41.7-1.3-75.6,32.6-74.3,74.3C185.3,222.6,216,253.3,253.7,254.5z"
      />
    </svg>
    <svg
      v-else-if="name == 'circle-user-solid_02'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M256,8.2C119.1,8.2,8.2,119.1,8.2,256S119.1,503.8,256,503.8S503.8,392.9,503.8,256S392.9,8.2,256,8.2z
       M256,472.8c-119.5,0-216.8-97.3-216.8-216.8S136.5,39.2,256,39.2S472.8,136.5,472.8,256S375.5,472.8,256,472.8z"
      />
      <g>
        <path
          class="st0"
          d="M334.7,396.3c69.7-18.2,56.8-121-15.3-121.8c-0.5,0-0.9,0-1.4,0H194c-0.5,0-1,0-1.5,0
          c-72,0.8-84.9,103.6-15.2,121.8c15.6,4.1,61.9,6.2,78.7,6.2C272.9,402.5,319.2,400.3,334.7,396.3z"
        />
        <path
          class="st0"
          d="M253.7,253.5c41.7,1.3,75.6-32.6,74.3-74.3c-1.2-37.7-31.9-68.4-69.6-69.6c-41.7-1.3-75.6,32.6-74.3,74.3
          C185.3,221.6,216,252.3,253.7,253.5z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'document-cancel'"
      fill="currentColor"
      :class="iconClass"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        d="M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L308 576C285.3 544.5 272 505.8 272 464C272 363.4 349.4 280.8 448 272.7L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM464 608C543.5 608 608 543.5 608 464C608 384.5 543.5 320 464 320C384.5 320 320 384.5 320 464C320 543.5 384.5 608 464 608zM523.3 427.3L486.6 464L523.3 500.7C529.5 506.9 529.5 517.1 523.3 523.3C517.1 529.5 506.9 529.5 500.7 523.3L464 486.6L427.3 523.3C421.1 529.5 410.9 529.5 404.7 523.3C398.5 517.1 398.5 506.9 404.7 500.7L441.4 464L404.7 427.3C398.5 421.1 398.5 410.9 404.7 404.7C410.9 398.5 421.1 398.5 427.3 404.7L464 441.4L500.7 404.7C506.9 398.5 517.1 398.5 523.3 404.7C529.5 410.9 529.5 421.1 523.3 427.3z"
      />
    </svg>
    <svg
      v-else-if="name == 'clock-nine-regular'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M278.7,255.5c0,12.8-10.3,23.2-23.2,23.2H150.2c-12.8,0-23.2-10.3-23.2-23.2c0-12.8,10.3-23.2,23.2-23.2h82.1
      V107.7c0-12.8,10.3-23.2,23.2-23.2c12.8,0,23.2,10.3,23.2,23.2V255.5z M502.8,255.5c0,136.6-110.7,247.3-247.3,247.3
      S8.2,392.1,8.2,255.5S118.9,8.2,255.5,8.2S502.8,118.9,502.8,255.5z M255.5,54.6c-111,0-200.9,89.9-200.9,200.9
      s89.9,200.9,200.9,200.9s200.9-89.9,200.9-200.9S366.5,54.6,255.5,54.6z M255.5-7935.5v16383 M-7935.5,255.5h16383 M290.5,256
      c0,19.1-15.5,34.5-34.5,34.5S221.5,275,221.5,256s15.5-34.5,34.5-34.5S290.5,236.9,290.5,256z"
      />
    </svg>
    <svg
      v-else-if="name == 'envelope-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g>
        <path
          class="st0"
          d="M501.4,179.3L366.4,280.6l129.9,122.8c3.3-7.6,5.2-15.9,5.2-24.7V179.3z"
        />
        <path
          class="st0"
          d="M29,154.8l208.6,156.5c10.9,8.1,25.9,8.1,36.8,0L483,154.8c11.6-8.7,18.4-22.3,18.4-36.8c0-25.4-20.6-46-46-46
          H56.6c-25.4,0-46,20.6-46,46C10.6,132.4,17.4,146,29,154.8z"
        />
        <path
          class="st0"
          d="M145.6,280.6l-135-101.3v199.4c0,9.5,2.1,18.4,6,26.4L145.6,280.6z"
        />
        <path
          class="st0"
          d="M334.7,304.4l-41.9,31.4c-21.9,16.4-51.8,16.4-73.6,0l-42-31.5L44.6,433.7c8.2,4.1,17.5,6.4,27.3,6.4h368.2
          c10.5,0,20.3-2.6,29-7.3L334.7,304.4z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'euro-sign-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 320 512"
      style="enable-background: new 0 0 320 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M51.3,240.5c-0.1,2.6-0.1,5.1-0.1,7.8v15.5c0,2.6,0,5.1,0.1,7.8H36c-17.2,0-31,13.9-31,31c0,17.2,13.9,31,31,31
      h27.1c28.7,81.4,106.4,129.9,197.5,129.9H284c17.2,0,31-13.9,31-31c0-17.2-13.9-31-31-31h-23.3c-56.1,0-104.9-21.7-129.8-67.9h102.7
      c17.2,0,31-13.9,31-31c0-17.2-13.9-31-31-31h-120c-0.1-2.5-0.2-5.1-0.2-7.8v-15.5c0-2.6,0.1-5.2,0.2-7.8h140c17.2,0,31-13.9,31-31
      s-13.9-31-31-31H130.9c24.9-46.2,73.7-67.9,129.8-67.9H284c17.2,0,31-13.9,31-31s-13.9-31-31-31h-23.3
      c-91.2,0-168.8,48.6-197.5,129.9H36c-17.2,0-31,13.9-31,31s13.9,31,31,31H51.3z"
      />
    </svg>
    <svg
      v-else-if="name == 'file-lines-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 384 512"
      style="enable-background: new 0 0 384 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M67.9,7.7C33.6,7.7,5.8,35.5,5.8,69.8v372.4c0,34.3,27.8,62.1,62.1,62.1h248.3c34.3,0,62.1-27.8,62.1-62.1
      V173.8c0-6-4.9-10.9-10.9-10.9H254.1c-17.1,0-31-13.9-31-31V18.6c0-6-4.9-10.9-10.9-10.9H67.9z M254.1,34v87c0,6,4.9,10.9,10.9,10.9
      h87c9.7,0,14.5-11.7,7.7-18.6l-87-87C265.8,19.4,254.1,24.3,254.1,34z M114.4,279.3h155.2c8.5,0,15.5,7,15.5,15.5
      c0,8.5-7,15.5-15.5,15.5H114.4c-8.5,0-15.5-7-15.5-15.5C98.9,286.3,105.9,279.3,114.4,279.3z M114.4,228.8h116.4
      c8.5,0,15.5,7,15.5,15.5c0,8.5-7,15.5-15.5,15.5H114.4c-8.5,0-15.5-7-15.5-15.5C98.9,235.8,105.9,228.8,114.4,228.8z M114.4,329.7
      h116.4c8.5,0,15.5,7,15.5,15.5c0,8.5-7,15.5-15.5,15.5H114.4c-8.5,0-15.5-7-15.5-15.5C98.9,336.7,105.9,329.7,114.4,329.7z
       M114.4,380.1h155.2c8.5,0,15.5,7,15.5,15.5s-7,15.5-15.5,15.5H114.4c-8.5,0-15.5-7-15.5-15.5S105.9,380.1,114.4,380.1z"
      />
    </svg>
    <svg
      v-else-if="name == 'gear-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M372.8,462.6l-2.2-46.6c-0.3-6.6,2.5-12.9,7.5-17.2c3.7-3.1,7.3-6.5,10.8-9.9c3.5-3.5,6.8-7.1,9.9-10.8
      c4.3-5,10.6-7.8,17.2-7.5l46.6,2.2c9.1,0.5,17.7-4.4,21.5-12.6l0.1,0c5.2-11.3,9.4-22.9,12.8-34.7l2.4-8.9c3-12.2,5.1-24.5,6.3-36.9
      c0.8-9-4.2-17.5-12.3-21.7L452,236.7c-5.8-3-9.9-8.6-11.1-15c-1.8-9.6-4.3-19.1-7.6-28.3c-2.2-6.2-1.5-13,2.1-18.6l25.1-39.2
      c4.9-7.7,5.1-17.5-0.3-24.9c-8-11.2-17-21.8-27-31.9c-10-10-20.7-19-31.9-26.9c-7.4-5.3-17.2-5.2-24.9-0.3l-39.2,25.1
      c-5.5,3.5-12.4,4.3-18.6,2.1c-9.3-3.3-18.7-5.8-28.3-7.6c-6.5-1.2-12-5.2-15-11.1l-21.4-41.4c-4.2-8-12.6-13.2-21.7-12.3
      c-12.4,1.2-24.7,3.3-36.9,6.3l-8.9,2.4c-11.8,3.4-23.4,7.6-34.7,12.8c-8.2,3.8-13.1,12.4-12.6,21.5l2.2,46.6
      c0.3,6.6-2.5,12.9-7.5,17.2c-3.7,3.1-7.3,6.5-10.8,9.9c-3.5,3.5-6.8,7.1-10,10.8c-4.3,5-10.6,7.8-17.2,7.5l-46.6-2.2
      c-9.1-0.5-17.7,4.4-21.5,12.6c-5.2,11.3-9.4,22.9-12.8,34.7l-2.4,8.9c-3,12.2-5.1,24.5-6.3,36.9c-0.8,9,4.2,17.5,12.3,21.7
      l41.3,21.3c5.9,3,9.9,8.6,11.1,15.1c1.8,9.6,4.3,19.1,7.6,28.3c2.2,6.2,1.5,13-2.1,18.6l-25.1,39.2c-4.9,7.7-5.1,17.5,0.3,24.9
      c8,11.2,17,21.8,27,31.9c10,10,20.7,19,31.9,27c7.4,5.3,17.2,5.2,24.9,0.3l39.2-25.1c5.5-3.5,12.4-4.3,18.6-2.1
      c9.3,3.3,18.7,5.8,28.3,7.6c6.5,1.2,12,5.2,15,11.1l21.4,41.4c4.2,8,12.6,13.2,21.7,12.3c12.4-1.2,24.7-3.3,36.9-6.3l8.9-2.4
      c11.8-3.4,23.4-7.6,34.7-12.8C368.4,480.3,373.3,471.7,372.8,462.6z M193.9,318c-34.2-34.2-34.2-89.8,0-124s89.8-34.2,124,0
      s34.2,89.8,0,124S228.2,352.2,193.9,318z"
      />
    </svg>
    <svg
      v-else-if="name == 'hard-drive-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M8.7,101.5c0-34.1,27.7-61.8,61.8-61.8h370.9c34.1,0,61.8,27.7,61.8,61.8v165.2c0,5-5.6,8-9.8,5.2
      c-14.8-10.1-32.7-15.9-52-15.9H70.6c-19.3,0-37.2,5.9-52,15.9c-4.2,2.8-9.8-0.2-9.8-5.2V101.5z M70.6,286.9h370.9
      c34.1,0,61.8,27.7,61.8,61.8v61.8c0,34.1-27.7,61.8-61.8,61.8H70.6c-34.1,0-61.8-27.7-61.8-61.8v-61.8
      C8.7,314.6,36.4,286.9,70.6,286.9z M311.8,413.4c20.4,1.3,37.2-15.5,35.9-35.9c-1.1-16.8-14.7-30.5-31.6-31.6
      c-20.4-1.3-37.2,15.5-35.9,35.9C281.3,398.6,294.9,412.3,311.8,413.4z M445.2,381.8c1.3-20.4-15.5-37.2-35.9-35.9
      c-16.8,1.1-30.5,14.7-31.6,31.6c-1.3,20.4,15.5,37.2,35.9,35.9C430.5,412.3,444.2,398.6,445.2,381.8z"
      />
    </svg>
    <svg
      v-else-if="name == 'house-chimney-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 576 512"
      style="enable-background: new 0 0 576 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g>
        <path
          class="st0"
          d="M555.9,232.3l-51.1-45V62.1c0-12.7-10.3-22.9-22.9-22.9h-47.1c-12.7,0-22.9,10.3-22.9,22.9v43.6L308.8,15
          c-5.8-4.8-13.6-6.8-20.3-6.8s-14.5,1-21.3,7.7L18.9,232.3c-6.7,6.7-9.6,14.3-9.7,22.8c-0.2,17.4,14.1,31.5,31.5,31.5h18.3
          c7.8,0,15.3-2.9,21-8.1L278,99.1c5.7-5.1,14.3-5.1,19.9,0l197.7,179.3c5.8,5.2,13.2,8.1,21,8.1h18.9v0.1c16.5,0,31-13.6,31-31.1
          C567.5,246.8,563.7,239.1,555.9,232.3z"
        />
        <path
          class="st0"
          d="M504.7,322.1c0-4.2-1.8-8.1-4.9-10.9l-27.2-24.6L297.9,128.1c-5.7-5.1-14.3-5.1-19.9,0L103.2,286.6l-27.2,24.6
          c-3.1,2.8-4.9,6.8-4.9,11v31.9c-0.1,0.9-0.1,1.7-0.1,2.7v117.5c0,16.3,13.2,29.5,29.5,29.5h24.7c1.2,0,2.3-0.1,3.5-0.2
          c1.5,0.1,2.9,0.2,4.4,0.2h31h32.5c16.3,0,29.5-13.2,29.5-29.5v-32.5v-61.9c0-17.1,13.9-31,31-31H319c17.1,0,31,13.9,31,31v61.9
          v32.5c0,16.3,13.2,29.5,29.5,29.5h32.5h31.5c1.4,0,2.7,0,4.1-0.1c1.1,0.1,2.1,0.1,3.2,0.1h24.7c16.3,0,29.5-13.2,29.5-29.5v-24.9
          c0.3-2.5,0.5-5.1,0.5-7.8L504.7,322.1z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'house-outline'"
      xmlns="http://www.w3.org/2000/svg"
      id="Ebene_1"
      data-name="Ebene 1"
      viewBox="0 0 47.96 43"
    >
      <path
        class="cls-1"
        style="fill: none; stroke: #8b8b8b; stroke-miterlimit: 10; stroke-width: 3px"
        d="m46.45,21.46c0,1.41-1.16,2.51-2.49,2.51h-2.49l.05,12.5c0,.21-.02.43-.03.64v1.26c0,1.72-1.39,3.13-3.13,3.13h-6.24c-1.72,0-3.13-1.39-3.13-3.13v-6.88c0-1.38-1.11-2.49-2.49-2.49h-5c-1.38,0-2.49,1.11-2.49,2.49v6.87c0,1.72-1.39,3.13-3.13,3.13h-4.38c-.11,0-.23,0-.34-.02-.1,0-.18.02-.28.02h-1.25c-1.72,0-3.13-1.39-3.13-3.13v-14.4h-2.51c-1.41,0-2.49-1.1-2.49-2.51,0-.7.23-1.33.79-1.87L22.31,2.12c.54-.54,1.16-.62,1.72-.62s1.16.16,1.64.54l19.94,17.53c.61.56.92,1.18.84,1.88Z"
      />
    </svg>
    <svg
      v-else-if="name == 'location-dot-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 384 512"
      style="enable-background: new 0 0 384 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M213.3,453.7c46.1-57.6,151.1-178.7,151.1-257.2c0-95.2-77.2-172.4-172.4-172.4S19.6,101.3,19.6,196.5
      c0,78.5,105,199.6,151.1,257.2c5.5,6.9,13.4,10.3,21.3,10.3S207.8,460.6,213.3,453.7L213.3,453.7z M192,256.5
      c-38.2,0-69.3-31.1-69.3-69.3s31.1-69.3,69.3-69.3s69.3,31.1,69.3,69.3S230.2,256.5,192,256.5z"
      />
      <g>
        <g>
          <path
            class="st0"
            d="M152.5,439.8c-5.9,1.8-11.8,3.8-17.4,5.9c-7.9,3.2-16.4,6.4-22,12.4c-0.7,0.8-1.2,1.7-1.3,2.2
              c-0.2,0.5,0.1,0.8,0.3,1.1c11.5,12.4,62.3,14.6,79.9,14.5c11.9,0,23.8-0.5,35.6-1.7c11.4-1.2,23.3-3,33.9-6.7
              c4-1.6,8.1-3,10.6-6.2c0.2-0.3,0.3-0.5,0.2-0.9c-0.1-0.5-0.6-1.4-1.3-2.2c-5.6-6-14.2-9.2-22-12.4c-5.7-2.1-11.5-4.1-17.4-5.9
              c14.3-0.1,43.2,1.9,50.9,15.8c3.2,5.8,0.7,13-4,17.2c-12.2,11.2-32.8,15.5-48.6,18.2c-25,3.8-50.5,3.8-75.6,0
              c-15.9-2.7-36.4-7-48.6-18.2c-4.6-4.2-7.2-11.5-4-17.2C109.4,441.7,138.2,439.7,152.5,439.8L152.5,439.8z"
          />
        </g>
      </g>
    </svg>
    <svg
      v-else-if="name == 'double-carrots-opposite-to-each-other-vertical-direction'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="iconClass"
    >
      <path d="M7 10L12 5L17 10" />
      <path d="M7 14L12 19L17 14" />
    </svg>
    <svg
      v-else-if="name == 'lock-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M146.6,148.6v33.8c0,6.5,5.2,11.7,11.7,11.7h131.4c6.5,0,11.7-5.2,11.7-11.7v-34.7c0-42.9-34.9-77.7-77.9-77.4
      C180.8,70.5,146.6,105.9,146.6,148.6z M84.7,182.4V149c0-77.1,62.1-140.6,139.2-140.7c77-0.1,139.5,62.4,139.5,139.3v34.7
      c0,6.5,5.2,11.7,11.7,11.7h3.8c34.2,0,61.9,27.7,61.9,61.9v185.8c0,34.2-27.7,61.9-61.9,61.9H69.2C35,503.7,7.3,476,7.3,441.8V256
      c0-34.2,27.7-61.9,61.9-61.9H73C79.4,194.1,84.7,188.8,84.7,182.4z"
      />
      <path
        class="st1"
        d="M266.6,318.1c0-24.5-20.7-44.2-45.6-42.5c-20.7,1.4-37.6,18.1-39.4,38.8c-1.4,16.5,6.7,31.3,19.3,39.5
      l-0.1,45.2c0,12.8,10.4,23.3,23.2,23.3h0c12.8,0,23.2-10.4,23.2-23.3l-0.1-45.2C258.8,346.3,266.6,333.1,266.6,318.1z"
      />
    </svg>
    <svg
      v-else-if="name == 'magnifying-glass-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M412.1,209.2c0,44.8-14.5,86.2-39,119.7l123.5,123.6c12.2,12.2,12.2,32,0,44.2c-12.2,12.2-32,12.2-44.2,0
      L328.9,373.1c-33.6,24.6-74.9,39-119.7,39C97.1,412.1,6.2,321.3,6.2,209.2S97.1,6.2,209.2,6.2S412.1,97.1,412.1,209.2z M209.2,349.7
      c77.6,0,140.5-62.9,140.5-140.5S286.7,68.7,209.2,68.7S68.7,131.6,68.7,209.2S131.6,349.7,209.2,349.7z"
      />
      <path
        class="st0"
        d="M107.2,243.1c12.2,3.3,24.8-7,24.4-20c-0.6-20.7,6.2-42,20.9-59.6c14.6-17.5,34.4-28.1,54.8-31.2
      c11.8-1.8,19.8-14.3,16-25.4c-0.3-0.8-0.6-1.5-0.9-2.3c-3.4-7.1-11.1-10.7-19-9.5c-29.4,4.5-57.8,19.8-78.9,45
      c-21.1,25.3-31,56.1-30.2,85.9c0.2,7.5,4.7,14.2,11.6,16.6C106.3,242.8,106.8,243,107.2,243.1z"
      />
    </svg>
    <svg
      v-else-if="name == 'map-pin-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 320 512"
      style="enable-background: new 0 0 320 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M298.9,147.9c0-77-62.8-139.5-140-138.9C83.8,9.5,22.2,70.6,21.1,145.9c-1,67,45.5,123.4,108,137.6v190
      c0,2.4,0.9,4.6,2.6,6.3l22,22c3.5,3.5,9.1,3.5,12.5,0l22-22c1.7-1.7,2.6-3.9,2.6-6.3v-190C252.7,269.4,298.9,214,298.9,147.9z
       M95.4,152.7c0,9.5-7.8,17.3-17.3,17.3c-9.5,0-17.3-7.8-17.3-17.3c0-57.4,46.6-104,104-104c9.5,0,17.3,7.8,17.3,17.3
      c0,9.5-7.8,17.3-17.3,17.3C126.5,83.3,95.4,114.4,95.4,152.7z"
      />
    </svg>
    <svg
      v-else-if="name == 'mobile-screen-button-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 384 512"
      style="enable-background: new 0 0 384 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M18,66.2C18,31.3,46.4,2.9,81.3,2.9h221.5c34.9,0,63.3,28.4,63.3,63.3v379.6c0,34.9-28.4,63.3-63.3,63.3H81.3
      c-34.9,0-63.3-28.4-63.3-63.3V66.2z M223.6,445.8c0-17.5-14.1-31.6-31.6-31.6s-31.6,14.1-31.6,31.6c0,17.5,14.1,31.6,31.6,31.6
      S223.6,463.3,223.6,445.8z M276.9,66.2H107.1c-14.3,0-25.8,11.6-25.8,25.8v274.6c0,14.3,11.6,25.8,25.8,25.8h169.8
      c14.3,0,25.8-11.6,25.8-25.8V92C302.7,77.7,291.2,66.2,276.9,66.2z"
      />
      <path
        class="st1"
        d="M232.4,44.4h-81.9c-4.1,0-7.5-3.4-7.5-7.5v0c0-4.1,3.4-7.5,7.5-7.5h81.9c4.1,0,7.5,3.4,7.5,7.5v0
      C239.9,41.1,236.5,44.4,232.4,44.4z"
      />
    </svg>
    <svg
      v-else-if="name == 'PDF_file_icon'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 213.5 262.5"
      style="enable-background: new 0 0 213.5 262.5"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g transform="translate(53.548057 -183.975276) scale(1.4843)">
        <path
          class="st0"
          d="M-17.8,123.9c-10.1,0-18.3,8.2-18.3,18.3v140.3c0,10.1,8.2,18.3,18.3,18.3H89.5c10.1,0,18.3-8.2,18.3-18.3
          V167.2c0,0,0.3-3.4-1.2-6.7c-1.4-3.1-3.6-5.2-3.6-5.2c0,0,0,0,0,0l-26.6-26.1c0,0,0,0,0,0c0,0-2.3-2.2-5.6-3.6
          c-4-1.7-8.1-1.5-8.1-1.5l0.1,0L-17.8,123.9z"
        />
        <path
          class="st1"
          d="M-17.8,129.9h80.4c0,0,0,0,0.1,0c0,0,3.2,0,5.6,1c2.3,1,3.9,2.4,3.9,2.5c0,0,0,0,0,0l26.6,26
          c0,0,1.6,1.7,2.4,3.4c0.6,1.4,0.7,4,0.7,4c0,0,0,0.1,0,0.1v115.5c0,6.8-5.4,12.3-12.3,12.3H-17.8c-6.8,0-12.3-5.4-12.3-12.3V142.2
          C-30.1,135.4-24.7,129.9-17.8,129.9L-17.8,129.9z"
        />
        <path
          class="st0"
          d="M-0.2,229.2c-4.1-4.1,0.3-9.8,12.5-15.8l7.6-3.8l3-6.5c1.6-3.6,4.1-9.4,5.4-13l2.4-6.5l-1.7-4.8
          c-2.1-5.9-2.8-14.7-1.5-17.9c1.8-4.3,7.6-3.9,9.9,0.8c1.8,3.6,1.6,10.1-0.5,18.4l-1.8,6.8l1.5,2.6c0.9,1.4,3.3,4.9,5.5,7.6l4.1,5.1
          l5.1-0.7c16.2-2.1,21.8,1.5,21.8,6.6c0,6.5-12.8,7.1-23.5-0.5c-2.4-1.7-4.1-3.4-4.1-3.4s-6.7,1.4-10,2.3c-3.4,0.9-5.1,1.5-10.1,3.2
          c0,0-1.8,2.5-2.9,4.4c-4.2,6.9-9.2,12.6-12.8,14.7C6.1,231.2,1.9,231.3-0.2,229.2z M6.3,226.9c2.3-1.4,7-7,10.3-12.1l1.3-2.1l-6,3
          c-9.3,4.7-13.5,9-11.3,11.7C1.9,228.9,3.3,228.8,6.3,226.9L6.3,226.9z M66.5,210c2.3-1.6,1.9-4.8-0.6-6.1c-2-1-3.6-1.2-8.8-1.1
          c-3.2,0.2-8.3,0.9-9.2,1.1c0,0,2.8,1.9,4.1,2.7c1.7,1,5.7,2.7,8.7,3.6C63.5,211.1,65.2,211,66.5,210L66.5,210z M42.3,200
          c-1.4-1.4-3.7-4.5-5.2-6.7c-1.9-2.5-2.9-4.3-2.9-4.3s-1.4,4.6-2.6,7.3l-3.6,9l-1.1,2c0,0,5.6-1.8,8.4-2.6c3-0.8,9.1-2,9.1-2
          L42.3,200z M34.5,168.7c0.4-2.9,0.5-5.9-0.4-7.4c-2.6-2.9-5.8-0.5-5.2,6.3c0.2,2.3,0.7,6.2,1.5,8.6l1.4,4.4l1-3.3
          C33.2,175.6,34,171.7,34.5,168.7L34.5,168.7z"
        />
        <path
          class="st0"
          d="M6.9,248.4h6.7c2.1,0,3.9,0.2,5.2,0.6c1.3,0.4,2.5,1.3,3.4,2.7c0.9,1.4,1.4,3,1.4,5c0,1.8-0.4,3.3-1.1,4.6
          c-0.7,1.3-1.7,2.2-3,2.8c-1.2,0.6-3.2,0.9-5.8,0.9h-2.3v10.6H6.9L6.9,248.4z M11.3,251.8v9.4h2.2c2,0,3.4-0.4,4.1-1.1
          c0.8-0.7,1.2-1.9,1.2-3.6c0-1.2-0.3-2.2-0.8-3c-0.5-0.8-1.1-1.3-1.7-1.4c-0.6-0.2-1.5-0.3-2.8-0.3L11.3,251.8z M26.9,248.4H33
          c2.9,0,5.3,0.5,7.1,1.6c1.8,1,3.1,2.6,4,4.7c0.9,2.1,1.4,4.4,1.4,6.9c0,2.6-0.4,5-1.2,7.1c-0.8,2.1-2,3.7-3.7,5
          c-1.7,1.3-4,1.9-7.1,1.9h-6.4V248.4z M31.4,252v19.9h1.9c2.6,0,4.5-0.9,5.7-2.7c1.2-1.8,1.8-4.2,1.8-7.2c0-6.6-2.5-10-7.4-10
          L31.4,252z M49.8,248.4h15v3.6H54.3v8.1h8.4v3.6h-8.4v11.8h-4.5L49.8,248.4z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'phone-office-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 576 512"
      style="enable-background: new 0 0 576 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M204.6,4.2h-85c-11.3,0-20.5,9.2-20.5,20.5v11v346.2v11c0,11.3,9.2,20.5,20.5,20.5h11h62.9h11
      c11.3,0,20.5-9.2,20.5-20.5v-11V35.7v-11C225.1,13.4,215.9,4.2,204.6,4.2z M47.2,35.7h-22c-11.3,0-20.5,9.2-20.5,20.5v431.2
      c0,11.3,9.2,20.5,20.5,20.5h525.6c11.3,0,20.5-9.2,20.5-20.5V56.2c0-11.3-9.2-20.5-20.5-20.5H277c-11.3,0-20.5,9.2-20.5,20.5v357.2
      v11c0,11.3-9.2,20.5-20.5,20.5h-11H99.2h-11c-11.3,0-20.5-9.2-20.5-20.5v-11V56.2C67.7,44.9,58.5,35.7,47.2,35.7z M339.9,98.6h147.9
      c11.3,0,20.5,9.2,20.5,20.5v53.5c0,11.3-9.2,20.5-20.5,20.5H339.9c-11.3,0-20.5-9.2-20.5-20.5v-53.5
      C319.5,107.8,328.6,98.6,339.9,98.6z M382.4,319.5v22c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22
      c0-11.3,9.2-20.5,20.5-20.5h22C373.3,299,382.4,308.2,382.4,319.5z M465.8,299h22c11.3,0,20.5,9.2,20.5,20.5v22
      c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22C445.4,308.2,454.5,299,465.8,299z M382.4,236.5v22
      c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22c0-11.3,9.2-20.5,20.5-20.5h22C373.3,216.1,382.4,225.2,382.4,236.5z
       M465.8,216.1h22c11.3,0,20.5,9.2,20.5,20.5v22c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22
      C445.4,225.2,454.5,216.1,465.8,216.1z M508.3,402.3v22c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22
      c0-11.3,9.2-20.5,20.5-20.5h22C499.1,381.9,508.3,391,508.3,402.3z M339.9,381.9h22c11.3,0,20.5,9.2,20.5,20.5v22
      c0,11.3-9.2,20.5-20.5,20.5h-22c-11.3,0-20.5-9.2-20.5-20.5v-22C319.5,391,328.6,381.9,339.9,381.9z"
      />
    </svg>
    <svg
      v-else-if="name == 'phone-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M166.1,27.6c-7.6-18.4-27.6-28.1-46.8-22.9L32.5,28.4C15.3,33.2,3.4,48.8,3.4,66.5
      c0,244.1,198,442.1,442.1,442.1c17.8,0,33.4-11.9,38.1-29.1l23.7-86.8c5.2-19.1-4.5-39.2-22.9-46.8l-94.7-39.5
      c-16.1-6.7-34.7-2.1-45.7,11.4l-20.4,24.9c-11.7,14.3-32.2,18-48.1,8.5c-47-28.2-86.5-67.6-114.6-114.6c-9.5-15.9-5.8-36.4,8.5-48.1
      l24.8-20.3c13.5-11.1,18.2-29.6,11.4-45.7L166.1,27.6L166.1,27.6z"
      />
      <path
        class="st0"
        d="M359.4,258c-17.7,0.8-16.3-16.5-17.6-21.4c0,0-11.3-53.6-70.8-67.1c-0.4-0.1-0.8-0.2-1.2-0.2
      c-2.7-0.5-18-4.2-14.6-19.6c3.8-17.2,27.9-12.2,43.8-4c15.3,7.9,55.4,23.9,72.7,83.2c1.4,4.7,1.8,9.7,1.1,14.6
      C371.8,250,368.7,257.6,359.4,258z"
      />
      <path
        class="st0"
        d="M290.4,101.8c-2.8-0.5-5.5-1.4-7.9-3c-5-3.3-11.5-9.8-6.7-20c7.3-15.6,30.5-6,41.5-3s48.4,17.9,76.3,47.8
      s38.2,52.1,43.5,70s13.3,46.5-8.3,46.5c0,0-14.9,0-17.3-14.9s-4.6-40.1-37.2-77C344.1,113.9,305.6,104.3,290.4,101.8z"
      />
    </svg>
    <svg
      v-else-if="name == 'trash-can-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <g>
        <path
          class="st0"
          d="M401.5,41.8h-88.8l-6.7-13.2c-5-10.1-15.3-16.4-26.4-16.4H168.3c-11.2,0-21.5,6.3-26.4,16.4l-6.7,13.2H46.5
          c-16.4,0-29.6,13.2-29.6,29.6c0,16.4,13.2,29.6,29.6,29.6h355.1c16.4,0,29.6-13.2,29.6-29.6C431.1,55,417.9,41.8,401.5,41.8z
           M169,41.8l4.1-5.5c3.1-4.2,9.5-6.8,16.4-6.8h69c6.9,0,13.3,2.6,16.4,6.8l4.1,5.5H169z"
        />
        <path
          class="st0"
          d="M32,437.1c0,35.3,28.7,64,64,64h256c35.3,0,64-28.7,64-64v-305c0-8.3-6.7-15-15-15H47c-8.3,0-15,6.7-15,15
          V437.1z M304,197.1c0-9.4,8.3-17,18-15.9c8.1,1,14,8.1,14,16.3v223.2c0,8.2-5.9,15.3-14,16.3c-9.7,1.2-18-6.4-18-15.9V197.1z
           M208,197.1c0-9.4,8.3-17,18-15.9c8.1,1,14,8.1,14,16.3v223.2c0,8.2-5.9,15.3-14,16.3c-9.7,1.2-18-6.4-18-15.9V197.1z M112,197.1
          c0-9.4,8.3-17,18-15.9c8.1,1,14,8.1,14,16.3v223.2c0,8.2-5.9,15.3-14,16.3c-9.7,1.2-18-6.4-18-15.9V197.1z"
        />
      </g>
    </svg>
    <svg
      v-else-if="name == 'truck-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 640 512"
      style="enable-background: new 0 0 640 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M244.3,5.1c-10.2,0-18.4,8.3-18.4,18.4v75.7h-49.7c-16.7,0-32.6,6.6-44.4,18.3l-75.8,75.8
      C44.3,205,37.8,221,37.8,237.7V256v31.4v62.7c-18.1,0-32.6,15.2-31.3,33.6c1.1,16,15.8,29.1,31.9,29.1h30.7
      c0,51.9,42.1,94.1,94.1,94.1s94.1-42.1,94.1-94.1h125.4c0,51.9,42.1,94.1,94.1,94.1s94.1-42.1,94.1-94.1h44.3
      c10.2,0,18.4-8.3,18.4-18.4V23.5c0-10.2-8.3-18.4-18.4-18.4H244.3z M213,256h-99.5c-7.2,0-13-5.8-13-13v0c0-3.4,1.4-6.7,3.8-9.2
      l68.2-68.2c2.4-2.4,5.7-3.8,9.2-3.8H213c7.2,0,13,5.8,13,13V243C225.9,250.2,220.1,256,213,256z M474.5,369.7
      c26.8-1.4,48.8,20.6,47.4,47.4c-1.2,22.9-19.8,41.5-42.7,42.7c-26.8,1.4-48.8-20.6-47.4-47.4C432.9,389.5,451.5,370.9,474.5,369.7z
       M118.2,417.1c-1.4-26.8,20.6-48.8,47.4-47.4c22.9,1.2,41.5,19.8,42.7,42.7c1.4,26.8-20.6,48.8-47.4,47.4
      C137.9,458.6,119.3,440,118.2,417.1z"
      />
    </svg>
    <svg
      v-else-if="name == 'wrench-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M499.9,119.1c-3-10.5-16-12.9-23.7-5.2l-75,75c-2.9,2.9-6.9,4.6-11,4.6h-56.1c-8.6,0-15.6-7-15.6-15.6v-56.1
      c0-4.1,1.7-8.1,4.6-11l75-75c7.7-7.7,5.3-20.7-5.2-23.7C379.1,8.1,364.7,6,349.8,6c-86.3,0-156.2,69.9-156.2,156.2
      c0,12.5,1.5,24.6,4.2,36.3c2.6,11.1-0.7,22.7-8.8,30.7L25.4,392.8C13,405.2,6,422.1,6,439.7C6,476.3,35.7,506,72.3,506
      c17.6,0,34.5-7,46.9-19.4l163.5-163.5c8-8,19.7-11.4,30.7-8.8c11.7,2.8,23.8,4.2,36.3,4.2c86.3,0,156.2-69.9,156.2-156.2
      C506,147.3,503.9,132.9,499.9,119.1z M110.7,459l-34,9.2c-2.2,0.6-4.6,0-6.3-1.7l-24.9-24.9c-1.6-1.6-2.3-4-1.7-6.3l9.1-34
      c0.6-2.2,2.3-4,4.6-4.6l34-9.2c2.2-0.6,4.6,0,6.3,1.7l24.9,24.9c1.6,1.6,2.3,4,1.7,6.3l-9.1,34C114.7,456.6,113,458.4,110.7,459z"
      />
    </svg>
    <svg
      v-else-if="name == 'xmark-solid'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 448"
      style="enable-background: new 0 0 448 448"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M306.5,153.5c12.2-12.2,12.2-31.9,0-44.1s-31.9-12.2-44.1,0l-98.8,98.9c-2,2-5.2,2-7.1,0l-98.9-98.8
      c-12.2-12.2-31.9-12.2-44.1,0s-12.2,31.9,0,44.1l98.9,98.8c2,2,2,5.2,0,7.1l-98.8,98.9c-12.2,12.2-12.2,31.9,0,44.1
      s31.9,12.2,44.1,0l98.8-98.9c2-2,5.2-2,7.1,0l98.9,98.8c12.2,12.2,31.9,12.2,44.1,0s12.2-31.9,0-44.1l-98.9-98.8c-2-2-2-5.2,0-7.1
      L306.5,153.5z"
      />
    </svg>
    <svg
      v-else-if="name == 'star-full'"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Ebene 1"
      viewBox="0 0 500 476.35"
      :class="iconClass"
    >
      <defs></defs>
      <path
        class="path-star-fill"
        d="m257.7,4.64l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.1c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.64c3.27-6.19,12.13-6.19,15.4,0Z"
      />
    </svg>

    <svg
      v-else-if="name == 'star-0.5'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="250" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-dead'"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Ebene 1"
      viewBox="0 0 500 476.35"
    >
      <defs></defs>
      <path
        class="path-star-dead"
        d="m257.7,4.64l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.1c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.64c3.27-6.19,12.13-6.19,15.4,0Z"
      />
    </svg>
    <svg
      v-else-if="name == 'star-0.1'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 499.93 476.37"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.69l73.5,139.4c1.3,2.4,3.6,4.1,6.2,4.5l155.3,26.9c6.9,1.2,9.6,9.6,4.8,14.6l-109.9,113c-1.9,1.9-2.8,4.6-2.4,7.3l22.4,156c1,6.9-6.2,12.1-12.5,9l-141.4-69.5c-2.4-1.2-5.3-1.2-7.7,0l-141.5,69.5c-6.3,3.1-13.4-2.1-12.5-9l22.4-156c.4-2.7-.5-5.4-2.4-7.3L2.5,190.09c-4.9-5-2.1-13.4,4.8-14.6l155.2-26.9c2.7-.5,4.9-2.1,6.2-4.5L242.3,4.59c3.3-6.1,12.1-6.1,15.4.1h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.69l73.5,139.4c1.3,2.4,3.6,4.1,6.2,4.5l155.3,26.9c6.9,1.2,9.6,9.6,4.8,14.6l-109.9,113c-1.9,1.9-2.8,4.6-2.4,7.3l22.4,156c1,6.9-6.2,12.1-12.5,9l-141.4-69.5c-2.4-1.2-5.3-1.2-7.7,0l-141.5,69.5c-6.3,3.1-13.4-2.1-12.5-9l22.4-156c.4-2.7-.5-5.4-2.4-7.3L2.5,190.09c-4.9-5-2.1-13.4,4.8-14.6l155.2-26.9c2.7-.5,4.9-2.1,6.2-4.5L242.3,4.59c3.3-6.1,12.1-6.1,15.4.1h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" width="50" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.2'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="100" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.3'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="150" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.4'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="200" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.6'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="300" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.7'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="350" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.8'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="13.92" width="372.17" height="476.37" />
      </g>
    </svg>
    <svg
      v-else-if="name == 'star-0.9'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      data-name="Ebene 1"
      viewBox="0 0 500 476.38"
      :class="iconClass"
    >
      <defs>
        <clipPath id="clippath">
          <path
            class="cls-1"
            d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
          />
        </clipPath>
      </defs>
      <path
        class="path-star-dead"
        d="m257.7,4.66l73.54,139.43c1.26,2.39,3.56,4.06,6.22,4.52l155.31,26.86c6.9,1.19,9.64,9.63,4.76,14.65l-109.92,112.98c-1.88,1.94-2.76,4.64-2.38,7.31l22.44,156c1,6.93-6.18,12.14-12.46,9.05l-141.37-69.54c-2.42-1.19-5.26-1.19-7.68,0l-141.47,69.55c-6.28,3.09-13.45-2.12-12.46-9.05l22.44-156c.38-2.67-.49-5.37-2.37-7.31L2.47,190.11c-4.88-5.02-2.14-13.45,4.76-14.64l155.23-26.86c2.66-.46,4.95-2.13,6.21-4.51L242.3,4.65c3.27-6.19,12.13-6.19,15.4,0h0Z"
      />
      <g class="cls-2">
        <rect class="path-star-fill" x="0" width="450" height="476.37" />
      </g>
    </svg>

    <svg
      v-else-if="name == 'menu'"
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 448 512"
      style="enable-background: new 0 0 448 512"
      fill="currentColor"
      xml:space="preserve"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M24,106c0-17.7,12.8-32,28.6-32h342.9c15.8,0,28.6,14.3,28.6,32s-12.8,32-28.6,32H52.6
    C36.8,138,24,123.7,24,106z M24,256c0-17.7,12.8-32,28.6-32h342.9c15.8,0,28.6,14.3,28.6,32s-12.8,32-28.6,32H52.6
    C36.8,288,24,273.7,24,256z M424,406c0,17.7-12.8,32-28.6,32H52.6C36.8,438,24,423.7,24,406s12.8-32,28.6-32h342.9
    C411.2,374,424,388.3,424,406z"
      />
    </svg>
    <svg
      v-else-if="name == 'expand-more'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        fill-rule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
        clip-rule="evenodd"
      />
    </svg>
    <svg
      v-else-if="name == 'chevron-right'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        fill-rule="evenodd"
        d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
        clip-rule="evenodd"
      />
    </svg>
    <svg
      v-else-if="name == 'chevron-down'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      :class="iconClass"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
    <!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      v-else-if="name == 'hand-under-money'"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 595.28 841.89"
      fill="currentColor"
    >
      <g id="Ji5wKa.tif">
        <g>
          <path
            class="st0"
            d="M332.62,468.22c0,0,0-0.01,0-0.01c-10.96,0-21.92,0-32.88,0c-0.75,0-1.5,0.03-2.24-0.08
              c-1.1-0.16-2.15-1.6-2.1-2.75c0.06-1.18,0.99-1.97,2.38-2.02c0.29-0.01,0.58,0,0.87,0c20.76,0,41.52-0.01,62.28-0.01
              c2.17,0,4.28-0.25,6.33-1.08c5.45-2.21,9.03-7.25,8.96-13.02c-0.07-6.2-4.05-11.4-9.85-13.07c-1.92-0.55-4-0.74-6.01-0.75
              c-14.78-0.06-29.56-0.04-44.34-0.01c-1.32,0-2.39-0.32-3.44-1.11c-3.68-2.77-7.4-5.48-11.1-8.21c-3.56-2.63-7.35-4.8-11.74-5.76
              c-3.45-0.76-6.92-0.46-10.41-0.43c-11.25,0.09-22.5,0.06-33.75,0.07c-4.57,0-9.13-0.09-13.7,0.01c-3.98,0.09-7.34,2.86-8.2,6.75
              c-0.36,1.64-0.41,3.37-0.41,5.06c-0.03,12.51-0.03,25.03,0,37.54c0.01,3.44,0.04,6.88,0.18,10.31c0.17,4.1,3.15,7.5,7.24,8.14
              c1.78,0.28,3.64,0.14,5.46,0.14c6.02-0.03,12.03-0.14,18.05-0.09c2.92,0.03,5.71,0.78,8.43,1.91c7.89,3.25,15.79,6.48,23.74,9.56
              c11.58,4.49,23.21,8.85,35.26,11.98c4.27,1.11,8.42,1.41,12.61-0.51c9.26-4.25,18.69-8.13,27.87-12.55
              c13.77-6.64,27.45-13.47,41.04-20.48c10.09-5.21,19.95-10.84,29.92-16.27c4.36-2.37,6.7-6.15,7.73-10.87
              c1.17-5.38-0.82-10.66-5.16-13.37c-2.85-1.78-6.06-2.39-9.33-1.93c-3.18,0.45-6.36,1.13-9.44,2.07
              c-12.04,3.65-24.04,7.45-36.07,11.17c-0.7,0.22-0.88,0.6-0.88,1.27c-0.02,2.11,0.13,4.25-0.16,6.32c-1,7.03-7.47,12.28-14.6,12.13
              C354.3,468.05,343.46,468.22,332.62,468.22z"
          />
          <path
            class="st0"
            d="M153.85,405.21c0-1.44,0.27-2.9,0.96-4.17c1.32-2.44,3.69-3.94,6.79-4.18c1.24-0.1,2.49-0.07,3.73-0.08
              c9.88-0.01,19.76,0.01,29.64-0.02c2.53-0.01,4.97,0.24,7.1,1.8c2.83,2.08,3.81,5.01,3.82,8.36c0.02,12.22,0.01,24.45,0.01,36.67
              c0,18.56,0,37.13,0,55.69c0,5.82-3.77,9.79-9.57,9.82c-11.25,0.07-22.5,0.05-33.75,0.01c-2.85-0.01-5.45-0.9-7.23-3.26
              c-1.12-1.48-1.26-3.38-1.26-6.18L153.85,405.21z"
          />
        </g>
      </g>
      <path
        class="st0"
        d="M333.97,328.13c-24.5,0-44.36,19.86-44.36,44.36c0,24.5,19.86,44.36,44.36,44.36
      c24.5,0,44.36-19.86,44.36-44.36C378.33,347.99,358.47,328.13,333.97,328.13z M347.66,400.83c-2.96,1.59-6.43,2.38-10.42,2.38
      c-3.26,0-6.19-0.55-8.79-1.65s-4.85-2.67-6.76-4.71c-1.91-2.04-3.47-4.5-4.69-7.38c-1.21-2.89-2.06-6.11-2.53-9.68h-5.61v-5.1h5.19
      c-0.03-0.36-0.04-0.72-0.04-1.09s0-0.74,0-1.13c0-0.53,0-1.05,0-1.55s0.03-1,0.08-1.51h-5.23v-5.1h5.82
      c0.61-3.46,1.6-6.57,2.95-9.35c1.35-2.77,3.03-5.14,5.02-7.09c1.99-1.95,4.27-3.46,6.82-4.52c2.55-1.06,5.32-1.59,8.3-1.59
      c3.82,0,7.08,0.72,9.79,2.15c2.7,1.44,5.01,3.41,6.9,5.92l-3.1,3.47c-0.25,0.28-0.52,0.52-0.79,0.73c-0.28,0.21-0.65,0.31-1.13,0.31
      c-0.33,0-0.67-0.12-1-0.36c-0.34-0.24-0.7-0.53-1.09-0.88c-0.39-0.35-0.84-0.73-1.36-1.15c-0.52-0.42-1.14-0.8-1.86-1.15
      c-0.72-0.35-1.58-0.64-2.55-0.88c-0.98-0.24-2.12-0.36-3.43-0.36c-1.81,0-3.49,0.31-5.02,0.94s-2.91,1.56-4.12,2.8
      c-1.21,1.24-2.25,2.78-3.12,4.62c-0.86,1.84-1.52,3.96-1.97,6.36h21.92v2.8c0,0.56-0.23,1.08-0.69,1.57
      c-0.46,0.49-1.08,0.73-1.86,0.73h-19.95c-0.06,0.5-0.08,1-0.08,1.51s0,1.02,0,1.55c0,0.39,0,0.77,0,1.13s0.01,0.73,0.04,1.09h18.62
      v2.8c0,0.56-0.23,1.08-0.69,1.57c-0.46,0.49-1.08,0.73-1.86,0.73h-15.6c0.78,5.22,2.39,9.11,4.83,11.69
      c2.44,2.58,5.49,3.87,9.14,3.87c1.42,0,2.66-0.14,3.7-0.42c1.05-0.28,1.95-0.62,2.72-1.03c0.77-0.4,1.42-0.85,1.97-1.34
      c0.54-0.49,1.03-0.93,1.46-1.34c0.43-0.4,0.82-0.75,1.15-1.02c0.33-0.28,0.7-0.42,1.09-0.42c0.28,0,0.52,0.04,0.73,0.13
      c0.21,0.08,0.42,0.25,0.65,0.5l3.85,3.6C353.08,396.97,350.61,399.24,347.66,400.83z"
      />
    </svg>

    <svg
      v-else-if="name == 'gear-check'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 287.24 184.9"
      fill="currentColor"
    >
      <defs></defs>
      <g id="_1Yzsmw.tif" data-name="1Yzsmw.tif">
        <path
          class="cls-1"
          d="m235.66,89.04c-2.14-2.74-4.46-5.34-6.64-8.05-3.09-3.85-5.4-8.2-6.19-12.99-.39-3.13-.18-6.4.59-9.8.48-2.13.77-4.32.93-6.5.31-4.48-1.17-6.87-5.3-8.68-1.89-.83-3.84-1.53-5.8-2.18-8.68-2.88-14.6-8.51-17.5-17.25-.72-2.16-1.46-4.32-2.41-6.37-1.76-3.76-5.89-5.78-9.99-5.09-2.74.47-5.45,1.08-8.2,1.44-6.36.82-12.31-.36-17.54-4.22-2.3-1.69-4.38-3.67-6.65-5.41-1.44-1.1-2.96-2.13-4.57-2.94-2.12-1.07-4.34-.78-6.27.49-1.96,1.29-3.88,2.71-5.61,4.29-4.02,3.67-8.43,6.54-13.86,7.57-4.09.78-8.15.41-12.2-.43-2.18-.45-4.4-.8-6.62-.93-2.97-.18-5.76,1.49-7.07,4.16-1.17,2.39-2.19,4.89-3.01,7.43-2.88,8.83-8.79,14.5-17.59,17.27-1.46.46-2.92.93-4.35,1.46-5.87,2.2-7.7,5.57-6.38,11.74.82,3.85,1.65,7.69,1.41,11.67-.35,5.71-2.27,10.82-5.85,15.28-2.18,2.71-4.5,5.31-6.64,8.05-1.48,1.9-1.52,5.3-.05,7.23,1.93,2.53,4,4.96,6.08,7.38,3.37,3.93,5.68,8.36,6.32,13.52.54,4.4-.06,8.74-.97,13.06-.43,2.03-.58,4.18-.47,6.26.13,2.5,1.65,4.36,3.86,5.42,2.11,1.02,4.35,1.8,6.57,2.56,9.25,3.17,15.79,8.99,18.51,18.64.38,1.35.83,2.69,1.34,4,2.16,5.57,5.45,7.32,11.31,6.11,3.52-.73,7.01-1.54,10.67-1.43,5.36.16,10.29,1.55,14.65,4.73,2.07,1.51,4.05,3.15,6.03,4.79,1.89,1.56,3.73,3.19,6.58,3.51,1.51.2,2.77-.05,2.77-.05,3.04-.57,4.93-2.89,7.16-4.7,2.37-1.92,4.75-3.9,7.36-5.44,4.67-2.76,9.8-3.66,15.19-2.7,2.19.39,4.39.81,6.55,1.32,6.13,1.44,10.49-.89,12.64-6.8.14-.39.24-.79.37-1.18.77-2.31,1.39-4.69,2.36-6.92,3.04-7.05,8.64-11.22,15.74-13.61,1.87-.63,3.78-1.15,5.62-1.85,4.36-1.66,6.75-6.39,5.7-10.94-.99-4.26-1.87-8.52-1.41-12.92.19-1.79.5-3.55.95-5.25,1.14-3.75,3.28-7.09,5.89-10.14,2.07-2.42,4.15-4.84,6.08-7.38,1.47-1.93,1.43-5.33-.05-7.23Zm-45.49-22.83l-59.37,59.92c-.74.72-1.91.69-2.6-.08-8.6-9.54-20.64-23.78-29.25-33.28-.8-.88-.79-1.4.13-2.24,3.56-3.24,6.54-5.99,10.04-9.3.68-.64,1.72-.57,2.31.16,9.92,12.31,4.23,5.74,14.11,17.99.25.35,1.05,1.38,1.75,2.28.52.67,1.5.75,2.09.15l48.95-48.58c.77-.76,2.02-.71,2.75.09,1.69,1.84,2.43,2.7,4.07,4.72,1.57,1.94,3.33,3.71,5.06,5.51,1.02,1.06.84,1.73-.04,2.65Z"
        />
      </g>
    </svg>

    <svg
      v-else-if="name == 'play-circle'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      :class="iconClass"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
      />
    </svg>

    <svg
      v-else-if="name == 'play'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="iconClass"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
      />
    </svg>
    <svg
      v-else-if="name == 'heart-shape'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="enable-background: new 0 0 512 512"
      xml:space="preserve"
      fill="currentColor"
      :class="iconClass"
    >
      <path
        d="M47.6,300.4l180.7,173.7c7.5,7,17.4,10.9,27.7,10.9c10.3,0,20.2-3.9,27.7-10.9l180.7-173.7c30.4-28.3,47.6-68,47.6-109.5
      v-5.8c0-69.9-50.5-129.5-119.4-141C347,36.5,300.6,51.4,268,84l-11.6,11.6c-0.2,0.2-0.6,0.2-0.8,0L244,84
      c-32.6-32.6-79-47.5-124.6-39.9C50.5,55.6,0,115.2,0,185.1v5.8C0,232.4,17.2,272.1,47.6,300.4L47.6,300.4z"
      />
    </svg>
    <svg
      v-else-if="name == 'heart-empty'"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="
        enable-background: new 0 0 512 512;
        fill: none;
        stroke: grey;
        stroke-width: 30;
        stroke-miterlimit: 10;
        overflow: visible;
      "
      xml:space="preserve"
      :class="iconClass"
    >
      <path
        class="st0"
        d="M47.6,300.4l180.7,173.7c7.5,7,17.4,10.9,27.7,10.9s20.2-3.9,27.7-10.9l180.7-173.7
      c30.4-28.3,47.6-68,47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347,36.5,300.6,51.4,268,84l-11.6,11.6c-0.2,0.2-0.6,0.2-0.8,0
      L244,84c-32.6-32.6-79-47.5-124.6-39.9C50.5,55.6,0,115.2,0,185.1v5.8C0,232.4,17.2,272.1,47.6,300.4L47.6,300.4z"
      />
    </svg>
    <svg
      v-else-if="name == 'doorout-arrow-solid'"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17.5"
      viewBox="0 0 20 17.5"
      stroke="currentColor"
      class="iconClass"
    >
      <path
        id="Pfad_85"
        data-name="Pfad 85"
        d="M14.762,4.637l4.8,4.8a1.509,1.509,0,0,1,0,2.133l-4.8,4.8a1.326,1.326,0,0,1-2.262-.937V13h-5a1.249,1.249,0,0,1-1.25-1.25V9.25A1.249,1.249,0,0,1,7.5,8h5V5.574a1.326,1.326,0,0,1,2.262-.937ZM6.25,4.25H3.75A1.249,1.249,0,0,0,2.5,5.5v10a1.249,1.249,0,0,0,1.25,1.25h2.5a1.25,1.25,0,0,1,0,2.5H3.75A3.751,3.751,0,0,1,0,15.5V5.5A3.751,3.751,0,0,1,3.75,1.75h2.5a1.25,1.25,0,0,1,0,2.5Z"
        transform="translate(0 -1.75)"
        fill="currentColor"
      />
    </svg>
    <svg
      v-else-if="name == 'person-with-headset'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.614 57.283"
    >
      <g
        id="Call_x2C__person_x2C__service_x2C__support_x2C__operator"
        transform="translate(1.055 0.875)"
      >
        <g id="XMLID_331_" transform="translate(0 0)">
          <path
            id="XMLID_1267_"
            d="M10.5,14.807c6.144,0,12.712-2.544,14.949-9.047"
            transform="translate(4.754 2.371)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_502_"
            d="M23.454,10.5h.954a1.909,1.909,0,0,1,1.909,1.909v5.726a1.909,1.909,0,0,1-1.909,1.909H22.5"
            transform="translate(15.659 6.678)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_3_"
            d="M10.363,10.5H9.409A1.909,1.909,0,0,0,7.5,12.409v5.726a1.909,1.909,0,0,0,1.909,1.909h1.909"
            transform="translate(2.028 6.678)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_4_"
            d="M37.131,18.678V15.815A14.316,14.316,0,0,0,22.815,1.5h0A14.316,14.316,0,0,0,8.5,15.815v2.863"
            transform="translate(2.937 -1.5)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_1268_"
            d="M23.964,13.33c-2.029-.158-4.592-2.863-5.176-4.894"
            transform="translate(12.286 4.803)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_576_"
            d="M16.5,21.226h8.589a4.771,4.771,0,0,0,4.772-4.772V15.5h0"
            transform="translate(10.207 11.222)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_6_"
            d="M14.312,27.409A21.1,21.1,0,0,1,10.5,14.966V10.5"
            transform="translate(4.754 6.678)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_585_"
            d="M11.974,23.464S14.648,28.3,19.659,28.3s7.65-4.825,7.65-4.825"
            transform="translate(6.094 18.459)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_384_"
            d="M38.572,40.5A11.437,11.437,0,0,0,32.355,32.8L21.684,27.749A3.818,3.818,0,0,1,19.5,24.3V19.5"
            transform="translate(12.933 14.857)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_370_"
            d="M21.58,19.359v5.068A3.818,3.818,0,0,1,19.4,27.878L8.725,32.932a11.442,11.442,0,0,0-6.217,7.692"
            transform="translate(-2.508 14.729)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_5_"
            d="M14.491,23.287a6.614,6.614,0,0,0,2.88.683c2.886,0,5.608-2.088,7.557-5.316"
            transform="translate(8.381 14.089)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
          <path
            id="XMLID_160_"
            d="M21.766,11a21.993,21.993,0,0,1,.269,3.495A22.925,22.925,0,0,1,20.911,21.6"
            transform="translate(14.215 7.133)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.75"
          />
        </g>
      </g>
    </svg>
    <svg
      v-else-if="name == 'expert'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 450.65 450.65"
    >
      <defs>
        <Style>
          .cls-1 { fill: #fff; } .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill:
          #eb6608; }
        </Style>
      </defs>
      <path
        class="cls-1"
        d="M0,224.9C0,100.52,100.52,0,224.9,0s225.75,101.37,225.75,225.75-100.52,225.75-224.9,224.9C101.37,450.65,0,350.13,0,224.9"
      />
      <polygon
        class="cls-2"
        points="62.19 145.67 172.08 145.67 180.6 164.41 71.56 164.41 62.19 145.67"
      />
      <polygon
        class="cls-2"
        points="76.67 174.64 185.71 174.64 195.08 193.38 85.19 193.38 76.67 174.64"
      />
      <polygon
        class="cls-2"
        points="90.3 202.75 199.34 202.75 208.71 221.49 99.67 221.49 90.3 202.75"
      />
      <polygon
        class="cls-2"
        points="391.87 145.67 382.5 164.41 273.46 164.41 281.98 145.67 391.87 145.67"
      />
      <polygon
        class="cls-2"
        points="377.39 174.64 368.87 193.38 258.97 193.38 268.35 174.64 377.39 174.64"
      />
      <polygon
        class="cls-2"
        points="363.76 202.75 354.39 221.49 245.34 221.49 254.71 202.75 363.76 202.75"
      />
      <polygon
        class="cls-2"
        points="209.56 79.23 225.75 51.11 241.94 79.23 209.56 79.23"
      />
      <polygon
        class="cls-2"
        points="263.23 117.56 273.46 136.3 178.04 136.3 188.27 117.56 263.23 117.56"
      />
      <polygon
        class="cls-2"
        points="258.12 108.19 193.38 108.19 204.45 89.45 247.05 88.6 258.12 108.19"
      />
      <polygon
        class="cls-2"
        points="62.19 307.53 71.56 288.79 180.6 288.79 172.08 307.53 62.19 307.53"
      />
      <polygon
        class="cls-2"
        points="76.67 278.57 85.19 259.83 195.08 259.83 185.71 278.57 76.67 278.57"
      />
      <polygon
        class="cls-2"
        points="90.3 250.46 99.67 230.86 208.71 230.86 199.34 250.46 90.3 250.46"
      />
      <polygon
        class="cls-2"
        points="391.87 307.53 282.83 307.53 273.46 288.79 382.5 288.79 391.87 307.53"
      />
      <polygon
        class="cls-2"
        points="377.39 278.57 268.35 278.57 258.97 259.83 368.87 259.83 377.39 278.57"
      />
      <polygon
        class="cls-2"
        points="363.76 250.46 254.71 250.46 245.34 230.86 354.39 230.86 363.76 250.46"
      />
      <polygon
        class="cls-2"
        points="209.56 373.98 241.94 373.98 225.75 402.09 209.56 373.98"
      />
      <polygon
        class="cls-2"
        points="263.23 335.64 188.27 335.64 178.04 316.9 273.46 316.9 263.23 335.64"
      />
      <polygon
        class="cls-2"
        points="258.12 345.02 247.05 363.76 204.45 363.76 193.38 345.02 258.12 345.02"
      />
      <path
        class="cls-2"
        d="M22.15,225.75c0,111.6,91.15,202.75,202.75,202.75s202.75-90.3,202.75-202.75S336.5,23,224.9,23,21.3,114.15,22.15,225.75M11.07,224.9C11.07,106.49,106.49,10.22,224.9,10.22s214.68,96.26,214.68,214.68-95.41,214.68-213.82,214.68S11.07,343.31,11.07,224.9"
      />
    </svg>
    <svg
      v-else-if="name == 'file-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
    >
      <path
        d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"
      />
    </svg>
    <svg
      v-else-if="name == 'folder-plus-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        d="M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
      />
    </svg>
    <svg
      v-else-if="name == 'folder-open-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        d="M88.7 223.8L0 375.8 0 96C0 60.7 28.7 32 64 32l117.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7L416 96c35.3 0 64 28.7 64 64l0 32-336 0c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224l400 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480L32 480c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
      />
    </svg>
    <svg
      v-else-if="name == 'folder-closed-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        d="M448 480L64 480c-35.3 0-64-28.7-64-64L0 192l512 0 0 224c0 35.3-28.7 64-64 64zm64-320L0 160 0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64z"
      />
    </svg>
    <svg
      v-else-if="name == 'file-pen-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 125.7-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
      />
    </svg>
    <svg
      v-else-if="name == 'file-circle-plus-solid'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
      />
    </svg>
    <svg
      v-else-if="name == 'code-pull-request'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        d="M305.8 2.1C314.4 5.9 320 14.5 320 24l0 40 16 0c70.7 0 128 57.3 128 128l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L400 192c0-35.3-28.7-64-64-64l-16 0 0 40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3l0 205.3c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-205.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
      />
    </svg>
    <svg
      v-else-if="name == 'code-branch'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        d="M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 87.8c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l0-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 6.7c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l0 6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-6.7 0-198.7C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
      />
    </svg>
    <svg
      v-else-if="name == 'eye'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <path
        d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
      />
    </svg>
    <svg
      v-else-if="name == 'scissors'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        d="M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
      />
    </svg>
    <svg
      v-else-if="name == 'copy'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
      />
    </svg>
    <svg
      v-else-if="name == 'paste'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        d="M160 0c-23.7 0-44.4 12.9-55.4 32L48 32C21.5 32 0 53.5 0 80L0 400c0 26.5 21.5 48 48 48l144 0 0-272c0-44.2 35.8-80 80-80l48 0 0-16c0-26.5-21.5-48-48-48l-56.6 0C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48l0 272 0 16c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-220.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L320 128l-48 0zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
      />
    </svg>
    <svg
      v-else-if="name == 'payback'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 291.1 291.1"
      style="enable-background: new 0 0 291.1 291.1"
      xml:space="preserve"
    >
      <path
        style="fill: #003eb0"
        d="M235.3,209.3c0,14.3-11.7,26-26,26H81.8c-14.4,0-26-11.7-26-26V81.8c0-14.3,11.7-26,26-26h127.4
      c14.4,0,26,11.7,26,26V209.3z"
      />
      <path
        style="fill: #ffffff"
        d="M81.8,60.5c-11.7,0-21.3,9.5-21.3,21.2v127.5c0,11.7,9.5,21.2,21.3,21.2h127.4
      c11.7,0,21.3-9.5,21.3-21.2V81.8c0-11.7-9.5-21.2-21.3-21.2H81.8z M209.3,240.1H81.8c-17,0-30.8-13.8-30.8-30.8V81.8
      C51,64.8,64.8,51,81.8,51h127.4c17,0,30.8,13.8,30.8,30.8v127.5C240.1,226.2,226.2,240.1,209.3,240.1"
      />
      <path
        style="fill: #ffffff"
        d="M115.9,141.8c-14.3,0-25.9-11.6-25.9-25.9c0-14.3,11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9
      C141.8,130.2,130.2,141.8,115.9,141.8z M115.9,95.2c-11.4,0-20.8,9.3-20.8,20.8c0,11.4,9.3,20.8,20.8,20.8
      c11.5,0,20.8-9.3,20.8-20.8C136.7,104.5,127.4,95.2,115.9,95.2z"
      />
      <path
        style="fill: #ffffff"
        d="M115.9,201c-14.3,0-25.9-11.6-25.9-25.9c0-14.3,11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9
      C141.8,189.4,130.2,201,115.9,201z M115.9,154.4c-11.4,0-20.8,9.3-20.8,20.8c0,11.4,9.3,20.8,20.8,20.8c11.5,0,20.8-9.3,20.8-20.8
      C136.7,163.7,127.4,154.4,115.9,154.4z"
      />
      <path
        style="fill: #ffffff"
        d="M175.1,201c-14.3,0-25.9-11.6-25.9-25.9c0-14.3,11.6-25.9,25.9-25.9s25.9,11.6,25.9,25.9
      C201,189.4,189.4,201,175.1,201z M175.1,154.4c-11.4,0-20.8,9.3-20.8,20.8c0,11.4,9.3,20.8,20.8,20.8c11.4,0,20.8-9.3,20.8-20.8
      C195.9,163.7,186.6,154.4,175.1,154.4z"
      />
      <path
        style="fill: #ffffff"
        d="M175.2,141.8c-14.3,0-25.9-11.6-25.9-25.9c0-14.3,11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9
      C201,130.2,189.4,141.8,175.2,141.8z"
      />
    </svg>
    <svg 
      v-else-if="name == 'unchained'"
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 16.859 14.005"
      fill="currentColor"
    >
      <g id="Link-07" transform="translate(-2 -5.95)">
        <path id="Pfad_303" data-name="Pfad 303" d="M28.761,12.361l1.156-1.156a2.223,2.223,0,0,0,0-3.172h0a2.223,2.223,0,0,0-3.172,0l-2.312,2.312a2.223,2.223,0,0,0,0,3.172h0l.134.134a.708.708,0,0,1,.027.968h0a.722.722,0,0,1-1.021.027l-.134-.134h0a3.7,3.7,0,0,1,0-5.242L25.67,7.039a3.7,3.7,0,0,1,5.242,0h0a3.7,3.7,0,0,1,0,5.242l-1.129,1.1a.7.7,0,0,1-1.021,0h0A.7.7,0,0,1,28.761,12.361Z" transform="translate(-14.514)" />
        <path id="Pfad_304" data-name="Pfad 304" d="M9.289,27.445,8.133,28.6a2.223,2.223,0,0,0,0,3.172h0a2.223,2.223,0,0,0,3.172,0l2.312-2.312a2.223,2.223,0,0,0,0-3.172h0l-.134-.134a.708.708,0,0,1-.027-.968h0a.722.722,0,0,1,1.021-.027l.134.134h0a3.7,3.7,0,0,1,0,5.242L12.38,32.767a3.7,3.7,0,0,1-5.242,0h0a3.7,3.7,0,0,1,0-5.242l1.1-1.1a.7.7,0,0,1,1.021,0h0A.679.679,0,0,1,9.289,27.445Z" transform="translate(-2.596 -13.902)" />
        <line id="Linie_49" data-name="Linie 49" x2="1.398" y2="1.371" transform="translate(14.919 15.237)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
        <line id="Linie_50" data-name="Linie 50" x2="1.962" transform="translate(16.397 14.162)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
        <line id="Linie_51" data-name="Linie 51" y1="1.962" transform="translate(13.843 16.715)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
        <line id="Linie_52" data-name="Linie 52" x1="1.398" y1="1.371" transform="translate(4.543 9.377)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
        <line id="Linie_53" data-name="Linie 53" x1="1.962" transform="translate(2.5 11.823)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
        <line id="Linie_54" data-name="Linie 54" y2="1.962" transform="translate(7.016 7.307)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
      </g>
    </svg>
  </i>
</template>
<script setup lang="ts">
interface Props {
  name: string;
  iconClass?: string;
}
defineProps<Props>();
</script>
<style lang="postcss">
.path-star-dead {
    fill: #ebebeb;
}
.path-star-fill {
    fill: #fedc10;
}
</style>